// Centralized configuration
// In Vercel, VITE_API_BASE_URL should be set to the production backend URL
// For local development, it defaults to localhost:8000

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || (import.meta.env.PROD ? "" : "http://localhost:8000");
